import { useState, useEffect } from 'react';
import {
  Code, Globe, Box, DollarSign, GitPullRequest,
  HelpCircle, FileText, ShoppingCart
} from 'react-feather';
import axios from 'axios';

const ANALYTICS_ALLOWED_IDENTIFIERS = ['promptcloud', 'apple_south_asia', 'ueit_us'];

const dataAccessSection = (orgId) => ({
  menutitle: 'Data',
  Items: [
    {
      title: 'Data Access', icon: Code, type: 'sub',
      children: [
        { path: `/organizations/${orgId}/data_download`,       title: 'Data Download',     type: 'link' },
        { path: `/organizations/${orgId}/api_details`,         title: 'API Details',       type: 'link' },
        { path: `/organizations/${orgId}/merge_and_upload_new`,title: 'Merge and Upload',  type: 'link' },
        { path: `/organizations/${orgId}/webhooks`,            title: 'Webhooks',          type: 'link' },
        ...(ANALYTICS_ALLOWED_IDENTIFIERS.includes(orgId)
          ? [{ path: `/organizations/${orgId}/analytics`, title: 'Analytics', type: 'link' }]
          : []),
      ],
    },
  ],
});

const operationsSection = (orgId) => ({
  menutitle: 'Operations',
  Items: [
    { path: `/organizations/${orgId}/sites`,               icon: Globe,           title: 'Sites',                type: 'link' },
    { path: `/organizations/${orgId}/feasibility_reports`, icon: FileText,        title: 'Feasibility Reports',  type: 'link' },
    { path: `/organizations/${orgId}/issues`,              icon: GitPullRequest,  title: 'Issues',               type: 'link' },
    { path: `/organizations/${orgId}/invoices`,            icon: DollarSign,      title: 'Billing',              type: 'link' },
  ],
});

const adminSection = () => ({
  menutitle: 'Admin',
  Items: [
    {
      title: 'Admin Section', icon: Box, type: 'sub',
      children: [
        { path: '/admins/feasibility_checks',     title: 'Feasibility Checks',  type: 'link' },
        { path: '/admins/feasibility_reports',    title: 'Feasibility Reports', type: 'link' },
        { path: '/admins/coupons',                title: 'Discount Coupons',    type: 'link' },
        { path: '/admins/search/new',             title: 'Search Page',         type: 'link' },
        { path: '/admins/org_mapping',            title: 'Organization Mapping',type: 'link' },
        { path: '/admins/data_stock_files',       title: 'Datastock Files',     type: 'link' },
        { path: '/admins/announcements/new',      title: 'New Announcement',    type: 'link' },
        { path: '/admins/organizations',          title: 'All Organizations',   type: 'link' },
        { path: '/admins/payments',               title: 'All Payments',        type: 'link' },
        { path: '/admins/invoices',               title: 'All Invoices',        type: 'link' },
        { path: '/admins/not_feasible_websites',  title: 'Not Feasible Sites',  type: 'link' },
      ],
    },
  ],
});

const internalSection = () => ({
  menutitle: 'Internal',
  Items: [
    { path: '/internal', icon: HelpCircle, title: 'Internal Dashboard', type: 'link' },
  ],
});

const externalLinksSection = (navDetails) => ({
  menutitle: 'Resources',
  Items: [
    {
      path: navDetails?.data_stock?.url,
      icon: ShoppingCart,
      type: 'external_link',
      title: 'Buy Dataset',
    },
  ],
});

export default function useSidebarMenu(orgIdentifier) {
  const [menu, setMenu] = useState([]);

  useEffect(() => {
    if (!orgIdentifier) return;

    let cancelled = false;
    const email = localStorage.getItem('authEmail');

    axios
      .get(`/api/v1/user/details?email=${email}&page_type=client&controller_name=dashboard`)
      .then((res) => {
        if (cancelled) return;
        const isAdmin = !!res?.data?.user?.is_admin;
        return axios
          .get('/api/v1/navigate_sidebar_details?page_type=client&controller_name=dashboard')
          .then((res3) => {
            if (cancelled) return;
            const navDetails = res3?.data?.navigate_sidebar_details;
            const sections = [
              dataAccessSection(orgIdentifier),
              operationsSection(orgIdentifier),
              ...(isAdmin ? [adminSection(), internalSection()] : []),
              externalLinksSection(navDetails),
            ];
            setMenu(sections);
          });
      })
      .catch(() => {
        if (!cancelled) setMenu([]);
      });

    return () => {
      cancelled = true;
    };
  }, [orgIdentifier]);

  return menu;
}
